import { useState } from 'react';
import AiDialog from './components/AiDialog';

export default function Home() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <div className="min-h-screen bg-cover bg-center bg-no-repeat" style={{ backgroundImage: 'url(https://static.readdy.ai/image/60b118764cf4b26a380d7a1d75710c17/199047e61c17ffae292be61ba3434b0d.png)' }}>
      {/* Floating Action Button */}
      <button
        onClick={() => setIsDialogOpen(true)}
        className="fixed bottom-6 right-6 w-14 h-14 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-full shadow-lg hover:shadow-xl hover:scale-110 transition-all cursor-pointer z-50 flex items-center justify-center group"
      >
        <i className="ri-chat-3-line text-2xl"></i>
        <span className="absolute right-full mr-3 px-3 py-1.5 bg-gray-900 text-white text-xs rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          开始智能问数
        </span>
      </button>

      {/* AI Dialog */}
      <AiDialog isOpen={isDialogOpen} onClose={() => setIsDialogOpen(false)} />
    </div>
  );
}
